import React from "react";
import styled from 'styled-components';
import PageTitle from "../components/PageSEO";
import Presentation from "./Presentation";
import Simulator from "./Simulator";
import SankeyChart from "./SankeyChart";
import SelectionPanel from "./SelectionPanel";

const LandingPageComponent = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    font-size: clamp(0.5rem, 2vw + 0.5rem, 1.7rem);
    font-family: Space Mono, monospace;
`;

const Section = styled.section`
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: center;
    padding: 10vh 6vw;
`;

const SectionInner = styled.div`
    width: 100%;
    max-width: 980px;
    display: flex;
    flex-direction: column;
    gap: 18px;
`;

const SectionTitle = styled.h2`
    margin: 0;
    font-size: clamp(1.4rem, 2.8vw + 0.6rem, 2.1rem);
    line-height: 1.1;
    color: #0b1b1b;
`;

const SectionLead = styled.p`
    margin: 0;
    max-width: 75ch;
    line-height: 1.5;
    color: #0b1b1b;
`;

function VotoDesperdicado() {
    return (
        <LandingPageComponent>
            <PageTitle
                title="Voto Desperdiçado"
                description="Descobre, em 1 minuto, se o teu voto elege deputados — e porque é que tantos votos acabam por não contar."
                canonical="/voto-desperdicado"
            />

            <section id="topo">
                <Presentation />
            </section>

            <Section id="selecao" aria-labelledby="selecao-title">
                <SectionInner>
                    <SectionTitle id="selecao-title">Explora por partido ou por círculo</SectionTitle>
                    <SectionLead>
                        Queres ter uma noção rápida do problema antes de simulares? Alterna entre <strong>Partidos</strong> e <strong>Círculos</strong>
                        para veres exemplos — e depois experimenta o simulador para o teu caso.
                    </SectionLead>
                    <SelectionPanel />
                </SectionInner>
            </Section>

            <Section id="simulador" aria-labelledby="simulador-title">
                <SectionInner>
                    <SectionTitle id="simulador-title">Simulador (1 minuto)</SectionTitle>
                    <SectionLead>
                        Seleciona o teu <strong>círculo eleitoral</strong> e o <strong>partido</strong> em que votaste. Explicamos de forma simples se,
                        nesse círculo, esse voto contribuiu para eleger deputados.
                    </SectionLead>
                    <Simulator />
                </SectionInner>
            </Section>

            <Section id="visualizacao" aria-labelledby="visualizacao-title">
                <SectionInner>
                    <SectionTitle id="visualizacao-title">Visualização</SectionTitle>
                    <SectionLead>
                        Uma visão global para perceberes como os votos se convertem (ou não) em mandatos.
                        Esta visualização é um complemento ao simulador — começa por simular o teu caso.
                    </SectionLead>
                    <SankeyChart />
                </SectionInner>
            </Section>
        </LandingPageComponent>
    );
}

export default VotoDesperdicado;
